export function defined<T>(value: T | null | undefined, message?: string): T {
  if (!value) {
    throw new Error(message ?? "Value isn't defined");
  }
  return value;
}

export type Noop = () => void;

export const noop: Noop = () => void 0;
